<template>
  <div class="card-result-fail-root">
    <div class="card-result-fail-info-container">
      <img
        src="@/assets/얼굴_실패.svg"
        width="103px"
        style="margin-bottom: 40px; margin-left: 10px"
      />
      <div
        style="
          font-weight: bold;
          font-size: 28px;
          line-height: 36px;
          color: var(--primary-100);
          margin-bottom: 24px;
        "
      >
        지원하지 않는 모드
      </div>
      <div
        style="
          font-weight: normal;
          text-align: center;
          font-size: 16px;
          line-height: 26px;
          color: var(--surface-high);
          margin-bottom: 16px;
        "
      >
        PC 모드를 지원하지 않습니다.<br />
        모바일에서 다시 시도해 주세요.
      </div>
    </div>
    <div class="button-container" @click="$emit('start')">확인</div>
  </div>
</template>

<script>
export default {
  name: 'PcFileUploadDisabledScreen',
};
</script>

<style lang="scss" scoped>
.card-result-fail-root {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.card-result-fail-info-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex-grow: 1;
}

.button-container {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 1rem;
  width: calc(100% - 60px);
  color: white;
  background-color: var(--primary-100);
  border-radius: 8px;
  height: 60px;
  margin: 0 30px 48px;
}
</style>
